import React from 'react';

export default function App() {
  // Declare a new state variable, which we'll call "count"

  return (
    <div>
      <p>This is scheduling</p>
    </div>
  );
}